export const LOGIN_SUCCESS = "login_success";
export const UNAUTHORIZE = "unauthorize"
export const JOB_CATEGORY = "job-category";
export const UPDATE_CATEGORY = "update-category";
export const SUBMIT_REQUISITION = "submit_requisition";
export const ADDITIONAL_REQUIRMENT = "additional_requirment";
export const LOCAL_BENEFIT = "local";
export const LOAD_BENEFIT = "load_benefit";
export const UPDATE_BENEFIT = "update_benefit"
export const EXPAT_BENEFIT = "expat";
export const REQUISITION_LIST = "requisition_list";
export const REQUISITION_ITEM = "requisition_item";
export const ENTITIES = "entities";
export const CATEGORY_LIST = "category_list"
export const CV_LIST = "cv_list";
export const CV_DETAIL = "cv_detail";
export const OPEN_MODEL = "open_modal"
export const JOB_LIST = "job_list";
export const JOB_DETAIL = "job_detail";
export const LOADING = "loading"
export const JOB_REQUIRMENT = "job_requirment"
export const JOB_DESCRIPTION = "job_description"
export const FORM_RESET = "from_reset"
export const JOB_EDIT = "edit_job"
export const DELETE_JOB_SUCCESS = "delete_job_success"
export const CREATE_JOB_BENEFIT = 'create_job_benefit'
export const CREATE_JOB_CATEGORY = 'create_job_category'
export const CREATE_JOB_DESCRIPTION = 'create_job_description'
export const CREATE_JOB_REQUIRMENT= 'create_job_requirment'
export const CREATE_JOB_SUCCESS = 'create_job_success'